var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnmuteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1743.75 1743.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#e3000f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 871.88,
    cy: 871.88,
    r: 871.88
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "617.37 1065.8 886.65 1275.36 886.65 468.39 617.37 677.95 617.37 1065.8"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 368.18,
    y: 681.48,
    width: 203.75,
    height: 380.79
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1091.08 1055.98 1187.71 959.36 1284.33 1055.98 1375.57 964.74 1278.94 868.12 1375.57 771.49 1284.33 680.25 1187.71 776.88 1091.08 680.25 999.84 771.49 1096.47 868.12 999.84 964.74 1091.08 1055.98"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnmuteIcon);
export default __webpack_public_path__ + "static/media/unmuteIcon.e955882d8589cc681062a4a7aed9c290.svg";
export { ForwardRef as ReactComponent };